// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';
import {mapFormValidation} from '../services/claim-validation-helper';
import {readLaborTypes} from '../../shared/action-creators/labor-types';
import {validAmountOfUse} from '../../shared/services/claim-shared-helper';

export const updateResponsibleAccountsDropDown = (accountId, dealerCollection, pin) =>

    dispatch => {

        dispatch({
            accountId,
            dealerCollection,
            type: actions.UPDATE_CLAIM_PARTS_RESPONSIBLE_ACCOUNTS
        });

        if (accountId) {

            readLaborTypes(accountId, pin)(dispatch);

        }

    };

export const updatePartsClaimPin = pin =>

    dispatch => {

        dispatch({
            property: 'pin',
            type: actions.UPDATE_CLAIM_PARTS_PROPERTY,
            value: pin
        });

        if (pin === '') {

            dispatch({
                property: 'useAmount',
                type: actions.UPDATE_CLAIM_PARTS_FORM_VALIDATION,
                validity: true
            });

        }

    };

export const updatePartsClaimProperty = (property, value) => ({
    property,
    type: actions.UPDATE_CLAIM_PARTS_PROPERTY,
    value
});

export const updatePartsClaimWorkOrderOne = workOrder => ({
    type: actions.UPDATE_CLAIM_PARTS_WORK_ORDER_ONE,
    workOrder
});

export const updatePartsClaimWorkOrderTwo = workOrder => ({
    type: actions.UPDATE_CLAIM_PARTS_WORK_ORDER_TWO,
    workOrder
});

export const updatePartsClaimRepairNumber = repairNumber => ({
    repairNumber,
    type: actions.UPDATE_CLAIM_PARTS_REPAIR_NUMBER
});

export const updateOwnershipStatusDropDown = (key, statusCollection) => ({
    key,
    statusCollection,
    type: actions.UPDATE_CLAIM_PARTS_OWNERSHIP_STATUS
});

export const updatePartsClaimFailurePart = partNumber => ({
    partNumber,
    type: actions.UPDATE_CLAIM_PARTS_FAILURE_PART
});

export const updatePartsClaimFailureDate = failureDate => ({
    failureDate,
    type: actions.UPDATE_CLAIM_PARTS_FAILURE_DATE
});

export const updatePartsClaimRepairDate = repairDate => ({
    repairDate,
    type: actions.UPDATE_CLAIM_PARTS_REPAIR_DATE
});

export const updatePartsClaimUnitDropDown = (key, unitCollection) => ({
    key,
    type: actions.UPDATE_CLAIM_PARTS_USE_AMOUNT_UNIT,
    unitCollection
});

export const updatePartsClaimUseAmount = (amount, index) => ({
    amount: validAmountOfUse(amount),
    index,
    type: actions.UPDATE_CLAIM_PARTS_USE_AMOUNT
});

export const updatePartsClaimPartUseUnitDropDown = (key, unitCollection) => ({
    key,
    type: actions.UPDATE_CLAIM_PARTS_PART_USE_AMOUNT_UNIT,
    unitCollection
});

export const updatePartsClaimPartUseAmount = amount => ({
    amount: validAmountOfUse(amount),
    type: actions.UPDATE_CLAIM_PARTS_PART_USE_AMOUNT
});

export const updatePartsClaimInputOnBlur = (property, value, claim) => ({
    property,
    type: actions.UPDATE_CLAIM_PARTS_FORM_VALIDATION,
    validity: mapFormValidation(property, value, claim)
});

export const resetPartsClaim = () => ({
    type: actions.RESET_CLAIM_PARTS
});

export const resetPartsProductDetails = () => ({
    type: actions.RESET_CLAIM_PARTS_PRODUCT_DETAILS
});

export const updateInstalledByDropDown = (key, installedByCollection) => ({
    installedByCollection,
    key,
    type: actions.UPDATE_CLAIM_PARTS_INSTALLED_BY
});

export const updateStickyHeaderVisibility = status =>

    dispatch => {

        const STICKY_STATUS_FIXED = 2;

        dispatch({
            isVisible: status === STICKY_STATUS_FIXED,
            type: actions.UPDATE_CLAIM_PARTS_STICKY_HEADER_VISIBILITY
        });

    };



// WEBPACK FOOTER //
// ./src/claim/parts/action-creators/claim-details.js